import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Token } from '../token.model';
import { map, switchMap, tap } from 'rxjs/operators';
import { AppConfiguration } from 'src/app/app.configuration';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import { ErrorToast } from '../toast/error.toast';
import { ProyectoPrivadaConfig } from './interfaces/token-manager.interface';
interface RequestBody {
  nombre: string;
  contrasena: string;
  id: string;
}

@Injectable({
  providedIn: 'root',
})
export class TokenManagerService {
  currentConexionIdSubject: BehaviorSubject<string>;
  currentConexionIdObservable: Observable<string>;
  tokenRecibido: Subject<boolean> = new Subject();

  private currentTokenSubject: BehaviorSubject<Token>;
  currentToken: Observable<Token>;
  proyectoPrivada$: Observable<ProyectoPrivadaConfig | null>;
  proyectoPrivadaSubject: BehaviorSubject<ProyectoPrivadaConfig | null>;

  constructor(private http: HttpClient, private config: AppConfiguration, private toastService: ToastrService) {
    this.currentTokenSubject = new BehaviorSubject<Token>(
      JSON.parse(localStorage.getItem('currentToken'))
    );
    this.currentToken = this.currentTokenSubject.asObservable();

    this.currentConexionIdSubject = new BehaviorSubject<string>('');
    this.currentConexionIdObservable =
      this.currentConexionIdSubject.asObservable();

    this.proyectoPrivadaSubject = new BehaviorSubject<ProyectoPrivadaConfig>(
      null
    );
    this.proyectoPrivada$ = this.proyectoPrivadaSubject.asObservable();
  }

  getProyectoPrivadaValue(): ProyectoPrivadaConfig {
    return this.proyectoPrivadaSubject.value;
  }

  setProyectoPrivadaValue(proyectoPrivada: ProyectoPrivadaConfig) {
    this.proyectoPrivadaSubject.next(proyectoPrivada);
  }

  getTaquillaToken(): string | null {
    return localStorage.getItem('taquillaToken');
  }

  public get currentTokenValue(): Token {
    return this.currentTokenSubject.value;
  }

  setCurrentConexionId(conexionId: string) {
    this.currentConexionIdSubject.next(conexionId);
  }

  public getCurrentConexionIdValue(): string {
    return this.currentConexionIdSubject.value;
  }
  createToken(): Observable<string | null> {
    const headers = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': 'true',
      'Access-Control-Allow-Headers': 'Content-Type',
      'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
    };

    const bodyToken = {
      usuario: environment.API_TOKEN_USER,
      contrasena: environment.API_TOKEN_PASSWORD,
    };

    return this.http
      .post<any>(`${this.config.getConfig('API_URL_TAQUILLA')}/Token`, bodyToken, { headers })
      .pipe(
        map(res => {
          if (!res.token) {
            this.toastService.error('', res.Mensajes?.[0]?.DescripcionMensaje || 'Error generando token', {
              toastComponent: ErrorToast,
              timeOut: 5000,
            });
            return null;
          }
          return res.token;
        }),
        tap(token => {
          if (token) {
            localStorage.setItem('taquillaToken', token);
          }
        })
      );
  }

  // --- Refactor de login para encadenar createToken sin exponer directamente el token ---
  login(numUser: string, chNombreProyecto?: string): Observable<Token> {
    const credenciales = {
      nombre: numUser,
      id: this.generarSessionId(),
      aplicacionCod: this.config.getConfig('chNombreProyecto') || ""
    };
    return this.http
      .post<any>(`${this.config.getConfig('API_URL')}api/IniciarLog`, credenciales)
      .pipe(
        map(res => {
          const tokenLogin = res.DatosResult;
          const session: Token = {
            sessionId: credenciales.id,
            token: tokenLogin,
            aplicacionCod: credenciales.aplicacionCod
          };
          localStorage.setItem('currentToken', JSON.stringify(session));
          localStorage.setItem('credentialId', credenciales.id);
          this.currentTokenSubject.next(session);
          this.tokenRecibido.next(true);
          return session;
        }),
        switchMap(session =>
          this.createToken().pipe(
            // No importa si token de createToken es nulo; devolvemos session de login
            map(() => session)
          )
        )
      );
  }

  TraerProyectoPrivada() {
    const token = JSON.parse(localStorage.getItem('currentToken'));
    const body = {
      chClaveEmpresa: this.config.getConfig('chClaveEmpresa'),
      chNombreProyecto: this.config.getConfig('chNombreProyecto'),
      ConexionIacpos: this.getCurrentConexionIdValue(),
    };

    console.log({
      message: 'TraerProyectoPrivada called',
      body
    });
    
    return this.http.post<any>(
      this.config.getConfig('API_URL') + 'api/TraerProyectoPrivada',
      body,
      {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*'
        })
      }
    ).pipe(
      map((result) => {
        let proyectoPrivada = result;
        proyectoPrivada.CaracteristicasAdicionales = JSON.parse(result.CaracteristicasAdicionales)
          ? JSON.parse(result.CaracteristicasAdicionales).CaracteristicasAdicionales
          : {};
        this.setProyectoPrivadaValue(proyectoPrivada);
        return result;
      })
    )
  }

  logout(): void {
    localStorage.removeItem('taquillaToken');
    localStorage.removeItem('currentToken');
    localStorage.clear();
    this.currentTokenSubject.next(null);
  }

  private generarSessionId(): string {
    const valorFechaActual = new Date().valueOf();
    const valorAleatorio = Math.random().toString().slice(-5);
    return '' + valorAleatorio + valorFechaActual;
  }

  private generarCredencialesRegistro(
    nombre: string,
    contrasena: string
  ): RequestBody {
    const credencialesRegistro: RequestBody = {
      nombre: nombre,
      contrasena: contrasena,
      id: this.generarSessionId(),
    };
    return credencialesRegistro;
  }

  private generarCredencialesCifradasRegistro(
    nombre: string,
    contrasena: string
  ) {
    const salt = '$A$';
    const trozosNombre = this.trocear(nombre);
    const trozosClave = this.trocear(contrasena);
    const clave =
      trozosNombre[0] +
      salt +
      trozosClave[0] +
      salt +
      trozosNombre[1] +
      salt +
      trozosClave[1];
    const credencialesRegistro = {
      nombre: clave,
      id: this.generarSessionId(),
    };
    return credencialesRegistro;
  }

  private trocear(string) {
    const mitad = Math.ceil(string.length / 2);
    return [string.slice(0, mitad), string.slice(mitad)];
  }
}
